const translations = {
  newTab: 'Nueva pestaña',
  filter: 'Filtrar',
  addWidget: 'Añadir Widget',
  closeEdit: 'Cerrar edición',
  welcome: '¡Bienvenido, {{name}}!',
  welcomeMessage: 'Vea lo que tenemos preparado para usted hoy.',
  dashboardTitle: 'Dashboard',
  'defaultTabs.productivity': 'Productividad',
  'defaultTabs.ranking': 'Ranking',
  'defaultTabs.efficiency': 'Eficiencia',
  'defaultTabs.volumeByStatus': 'Volumen de actividades por estado',
  'removeScreen.confirm': '¿Está seguro de que desea eliminar?',
  'removeScreen.success': '¡Pantalla eliminada con éxito!',
  'removeScreen.error': '¡Ocurrió un error al eliminar!'
}

export default translations
